import { render, staticRenderFns } from "./shlist.vue?vue&type=template&id=66c70368"
import script from "./shlist.vue?vue&type=script&lang=js"
export * from "./shlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports